import React from 'react'
import "./Everest-Heli.css"
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faCalendarCheck,faSliders,faCheck,faStar,faPhotoFilm,faXmark, faDownload, faMinus, faPlus, faTag,faEnvelope ,faCalendarDays, faCloud, faGaugeHigh, faUsers,faBus, faMapLocationDot, faFlag, faRulerVertical, faSquareArrowUpRight,faArrowRight,faChevronDown, faChevronUp, faBolt, faMicrophone,faMessage} from '@fortawesome/free-solid-svg-icons'
import { faWhatsapp,faWeixin, } from '@fortawesome/free-brands-svg-icons'
import { useState } from 'react'
import {useEffect} from 'react'
import PackageSlider from "./Component/PackageSlider";
import OBookingform from "./Component/obookingform";
import Enquiryform from "./Component/enquiryform";
import Review from "./Component/review";
import TourNav from './Component/stickynav';
const packages = [
  {
    title: "7 Unesco Heritage Tour",
    days: "4 Hours",
    duration: "8-9 Hours",
    difficulty: "Easy",
    price: 190,
    image: "/img/capital/pasupatinath.jpg",
    link: "/one-day-nepal-7unescoheritage-tour"
  },
  {
    title: "Nepal Golden Triangle Tour",
    location: "Nepal",
    days: "8 Days",
    difficulty: "Easy",
    price: 940,
    duration: "8 Days",
    image: "/img/chitwan/chitwan3dslr.webp",
    link: "/kathmandu-chitwan-pokhara-8days-nepaltour"
  },
  {
    title: "Peak & Safaris",
    location: "Nepal",
    days: "6 Days",
    difficulty: "Easy",
    price: 1150,
    duration: "6 Days",
    image: "/img/capital/nagarkot.webp",
    link: "/kathmandu-chitwan-nagarkot"
  },
  {
    title: "Nature Majestic Loop",
    location: "Nepal",
    days: "10 Days",
    difficulty: "Easy",
    price: 2350,
    duration: "10 Days",
    image: "/img/treek/Dhampus.webp",
    link: "/kathmandu-chitwan-lumbini-pokhara-ghandrukh-dhampush-bandipur-nagarkot-10daystour"
  }
];
const images = [
  "/img/mounteve/Heli1.webp",
  "/img/mounteve/helieve.webp",
  "/img/mounteve/helisc.webp",
  "/img/mounteve/heli2.webp", 
  "/img/company/flightdslr.jpeg", 
];
const EverestHeliTour = () => {
  const [open, setOpen] = useState(false);
  const [count,Setcount]=useState(1);
  const [day1Open, setDay1Open] = useState(false);
  const [index, setIndex] = useState(0);
const getmul=(qty)=>{
if(qty===1)return 1400;
if(qty===2)return 1379;
if(qty===3)return 1350;
if(qty===4 )return 1300;
if(qty>=5)return 1250;
};
const totalprice =count*getmul(count);
const [opent, seT] = useState(false);
const [opente, seTe] = useState(false);
const [openr, seTr] = useState(false);
useEffect(()=>{
  if(opent){
    document.body.style.overflow='hidden';
  }
  else{
    document.body.style.overflow='unset';
  }
  return()=>{
    document.body.style.overflow='unset';
  }
},[opent]);
const [activeIndex, setActiveIndex] = useState(null);

  const toggleFaq = (index) => {
    if (activeIndex === index) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  };
  const next = () => {
    setIndex((index + 1) % images.length);
  };

  const prev = () => {
    setIndex((index - 1 + images.length) % images.length);
  };
  return (
   <main>
 <TourNav />
    <div className='main'>
    <div className='Left'>
    <h1 className="tourTitle">Everest Helicopter Tour</h1>

    <div className="breadcrumb">
      <span>4 Hour Helicopter Tour</span>
    </div>
     <div className="everest-image">
        <div className="everest-full">
          <img src="/img/mounteve/heli2.webp" alt="error" />
          <div
      className="tourgps"
      onClick={() => setOpen(true)}
    >  <FontAwesomeIcon icon={faPhotoFilm}></FontAwesomeIcon> View Gallery
       </div>  
        </div>
        <div className="everest-half">
        <div className="image-box"> <video src="/video/videodslr.mp4" controls autoPlay muted loop></video></div>
            <div className="image-box"> <img src="/img/capital/pro.webp" alt="error" /></div>
        </div>
     </div>
     {open && (
  <div className="roomModal tourgr">
    <div className="roomModal__content">

      <div
        className="roomModal__close"
        onClick={() => setOpen(false)}
      >
        ✕
      </div>

      <img
        src={images[index]}
        alt="big"
        className="roomModal__image"
      />

      <div
        className="roomModal__nav roomModal__nav--left"
        onClick={prev}
      >
        ❮
      </div>

      <div
        className="roomModal__nav roomModal__nav--right"
        onClick={next}
      >
         ❯  
      </div>

      <div className="roomModal__thumbs">
        {images.map((img, i) => (
          <img
            key={i}
            src={img}
            alt="thumb"
            className={
              index === i
                ? "roomModal__thumb active"
                : "roomModal__thumb"
            }
            onClick={() => setIndex(i)}
          />
        ))}
      </div>

    </div>
  </div>
)}
    <div className="Trip-fact">
      <h3>Trip Facts</h3>
      <div className="grid">
        <div className="grid-item">
          <FontAwesomeIcon icon={faCalendarDays}/>
          <div className="grid-item-next">
            <p className='Dur'>Duration</p>
            <p className='Duration'>4 Hours</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faCloud}/>
          <div className="grid-item-next">
            <p className='Dur'>Best Time</p>
            <p className='Duration'>Mar-May/Aug-Dec</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faGaugeHigh}/>
          <div className="grid-item-next">
            <p className='Dur'>Grade</p>
            <p className='Duration'>Easy</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faBus}/>
          <div className="grid-item-next">
            <p className='Dur'>Transportation</p>
            <p className='Duration'>Private Helicopter</p>
          </div>
        </div>
 
        <div className="grid-item">
          <FontAwesomeIcon icon={faMapLocationDot}/>
          <div className="grid-item-next">
            <p className='Dur'>Type Of Tour</p>
            <p className='Duration'>Heli Tour</p>
          </div>
        </div>

         <div className="grid-item">
          <FontAwesomeIcon icon={faFlag}/>
          <div className="grid-item-next">
            <p className='Dur'>Trip Starts&End</p>
            <p className='Duration'>Kathmandu</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faUsers}/>
          <div className="grid-item-next">
            <p className='Dur'>Minimum Pax</p>
            <p className='Duration'>1 Pax</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faRulerVertical}/>
          <div className="grid-item-next">
            <p className='Dur'>Maximum Elevation</p>
            <p className='Duration'>19000 Ft</p>
          </div>
        </div>

      </div>

       </div>
       <div className="overview-container"id='overview'>
  <div className="heading">Highlights Of Tours</div>
  <div className="flex-p">
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Exploring natural beauty of Nepal like Birds.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Enjoy sunrise along with magnificent mountains view from window of Heli. </p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Explore different city of Nepal which is on the way of Mt.Everest. </p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> View of Mt.Everest from Kalapatthar view point.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> We handle all the permits, logestics and tickets; you only enjoy the views.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Enjoying breakfast at Everest view Hotel.</p>
  </div>
</div>
       <div className="overview-container">
  <div className="overview-heading">Overview</div>

  <div className="overview-text">
  Mt.Everest is the tallest mountain in the world and if you in Nepal tour and donot see it,your tour is incomplete.The climbing of mountain is very difficult for people from economic,time and strengt point of view if you are adventurous and willing to challenge above difficulty and plane to climb Everest its great but people who want to see tallest mountain of world but they dont have long time to spend in Nepal and their budget also dont support them to climb Mt.Everest then our Heli Tour is great for you we have arranged this heli tour to have a look of himalayan range and Everest itself from the window of helicopter in short time.At first the tour will round the Kathmandu valley and then fly towards Everest through Ganesh himal,Langtang,Lakpa,Choyo,Gaurishankar.It will land at Kalapatthar view point to have a look and take photos for memory.Finally it will land at Everest view hotel for breakfast and then fly back to Kathmandu.The flight will be of 3 hours and 1 hour breakfast and photo session.So it take 4 hours for heli tour.
  </div>
  <div className="heading smalling">Places You’ll Visit:</div>
  <div className="flex-p">
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Lukla:</b> The Cliffside Gateway</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Kala Patthar:</b> The Closest Viewpoint</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Everest Base Camp (Flyover):</b> The Climbers' Camp</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Hotel Everest View:</b> Breakfast Above the Clouds</p>
  </div>
  <div className="heading smalling">Introduction Of Places</div>
  <p className='overview-text'><b>Lukla: The Gateway in the Clouds</b> Your journey begins at one of the world’s most famous mountain airports, carved right into the side of a cliff. As the helicopter stops to refuel, you will feel the crisp Himalayan air for the first time and see the colorful gates that lead to the roof of the world. It is the buzzing start line where every great Everest story begins.</p>
  <p className='overview-text'><b>Kala Patthar: The Ultimate Viewpoint</b> This is the closest a helicopter can safely get to the peak, landing on a famous "black rock" higher than most mountains on Earth. Standing here, Mount Everest is so close it feels like you could reach out and touch it. It is a rare, silent moment in the heart of the giants that very few people ever get to witness.</p>
  <p className='overview-text'><b>Everest Base Camp (Flyover): The Climbers' Home</b> From your window, you will look down at the legendary Khumbu Glacier and the bright yellow tents of the world’s bravest climbers. You get a bird’s-eye view of the dangerous Icefall and the winding path people spend weeks walking. It is a perspective that makes you realize just how massive and wild the Himalayas truly are.</p>
  <p className='overview-text'><b>Hotel Everest View: Breakfast with a View</b> Finish your adventure at one of the highest hotels on the planet, where your coffee comes with a panoramic view of the Everest range. Relax on the terrace and watch the peaks while you breathe in the mountain peace. It is the most luxurious way to say goodbye to the world’s tallest mountain before flying home.</p>
</div>


<div className="overview-container">
  <div className="overview-heading">Why This Package ?</div>
 <p className='overview-text'>The Everest Heli Tour is the fastest and most comfortable way to experience the world's highest mountain region.This short yet unforgettable 4-hour helicopter tour is designed for travelers who want to see the Himalayas without long trekking days. It is ideal for tourists with limited time who still want a premium mountain adventure.</p>
 <div className="heading smalling">Spectacular Himalayan Mountain Views</div>
 <p className='overview-text'>This helicopter tour offers breathtaking aerial views of the Himalayas, including the iconic Mount Everest. You will witness towering snow-covered peaks, vast glaciers, deep valleys, and dramatic landscapes that define Nepal's natural beauty. Seeing these mountains from the air gives a unique and unforgettable perspective.</p>
 <div className="heading smalling">Natural Beauty of the Everest Region</div>
 <p className='overview-text'>As the helicopter flies over remote Himalayan terrain, you can enjoy pristine nature, frozen rivers, alpine forests, and traditional mountain villages. The untouched beauty of the Everest region creates a peaceful yet powerful experience, making this tour perfect for nature lovers and photographers.</p>
 <div className="heading smalling">Perfect 4-Hour Duration for Busy Travelers</div>
 <p className='overview-text'>The 4-hour duration makes this tour ideal for travelers who want a complete Everest experience in a short time. Within just a few hours, you can explore the heart of the Himalayas, enjoy scenic flights and landings, and return comfortably the same day.</p>
 <div className="heading smalling">Once-in-a-Lifetime Himalayan Experience</div>
 <p className='overview-text'>The Everest Heli Tour is more than just a sightseeing flight—it is a once-in-a-lifetime journey above the world's most famous mountains. Combining natural beauty, adventure, and luxury, this 3-hour helicopter tour offers an unforgettable Himalayan experience.</p>
</div>

<div className="overview-container">
  <div className="overview-heading"id='itinerary'>ITINERARY</div>
  <div className="timeline-row">
        <div className="timeline-left">
          <div className="day-circle">Day 1</div>
        </div>

        <div
          className="timeline-right"
          onClick={() => setDay1Open(!day1Open)}
        >
         
          <div className="timeline-title">
            Climbing Mt Everest Without Physically Climbing
          </div>

          <div className="arrow-icon">
            <FontAwesomeIcon icon={day1Open ? faChevronUp : faChevronDown} />
          </div>
        </div>
      </div>

      {day1Open && (
        <div className="timeline-detail">
         First we will pick you up from your pickup point towards Helicopter.then first helicopter revolve around in the sky of kathmandu city to show beautiful view of city from top angle then Heli fly toward Mt everset base camp which is the center of Heli tour there you will see tallest mountain of world and capture your memory inside mobile phone then you will go to the Everst view hotel to take your breakfast there also you can enjoy the friendship with view of nature after enjoyment you take heli toward kathmandu and we will drop you out to your drop out point and your tour is accomplished. In this way you can get feeling of climbing mountain without actually climb it up.
        </div>
      )}

 
</div>
<div className="overview-container width-hund"id='included'>

<div className="cost-box included">
        <div className="cost-title">Cost Included</div>

        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">
          Pick Up and Drop with private vehicle is included in this price.
          </div>
        </div>

        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">
          All the Permit Fee is included.
          </div>
        </div>


        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">Fare of the Helicopter for 3hours flight</div>
        </div>

        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">Oxygen Cylinder for emergency is also included.</div>
        </div>
        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">All kind of service charge and Tax is included.</div>
        </div>
        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">Life Insurance provided by aviation during a Helicopter flight.</div>
        </div>
      </div>



      {/* COST EXCLUDED */}
      <div className="cost-box excluded">
        <div className="cost-title">Cost Not Included</div>

        <div className="cost-item">
          <div className="icon-circle red">
            <FontAwesomeIcon icon={faXmark} />
          </div>
          <div className="cost-text">Accommodation in Kathmandu is not Included</div>
        </div>

        <div className="cost-item">
          <div className="icon-circle red">
            <FontAwesomeIcon icon={faXmark} />
          </div>
          <div className="cost-text">Breakfast is not Included It Cost Around 30$ Per Person</div>
        </div>

        <div className="cost-item">
          <div className="icon-circle red">
            <FontAwesomeIcon icon={faXmark} />
          </div>
          <div className="cost-text">Other Expenses like Mineral Water,Beaverage is not Included.</div>
        </div>

        <div className="cost-item">
          <div className="icon-circle red">
            <FontAwesomeIcon icon={faXmark} />
          </div>
          <div className="cost-text">Your Expenses like Tips,Purchasing Equipment and things also not Included.</div>
        </div>
      </div>

</div>
<div className="overview-container">
  <div className="heading vbn"><FontAwesomeIcon icon={faMessage}></FontAwesomeIcon> FAQS
  </div>
  <section className="faq">
      <div className="faq-container">

        <div className="faq-list">
          <div className="faq-item" onClick={() => toggleFaq(0)}>
            <div className="faq-question">
            Booking & Payment Terms
              <span>{activeIndex === 0 ? "-" : "+"}</span>
            </div>
            {activeIndex === 0 && (
              <div className="faq-answer">
                There is need of payment to book this package you need to pay 100% Charge for booking while there is refund policies incase of cancellation see below.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(1)}>
            <div className="faq-question">
              How can I book a tour?
              <span>{activeIndex === 1 ? "-" : "+"}</span>
            </div>
            {activeIndex === 1 && (
              <div className="faq-answer">
                You can book directly from our website by clicking button  or contact our support team from right side contact details in desktop and little bit below in mobile screen or from contact us page where is QR also for your ease scan and contactus.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(2)}>
            <div className="faq-question">
              Is This Package Suitable For Me ?
              <span>{activeIndex === 2 ? "-" : "+"}</span>
            </div>
            {activeIndex === 2 && (
              <div className="faq-answer">
               This package is built for those who want the ultimate Himalayan experience without the physical demand of a 12-day trek. It is the perfect choice for busy travelers who only have a few hours to spare but refuse to leave Nepal without seeing the world’s highest peak up close. Families with children or seniors can now share this "bucket list" moment together in total safety and comfort. It is also an elite option for photography enthusiasts and luxury seekers who want a front-row seat to Everest and a high-altitude breakfast. If you are looking for a secret shortcut to the clouds to celebrate a special milestone, this journey is designed exactly for you.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(3)}>
            <div className="faq-question">
              Can I cancel my booking and refund policies?
              <span>{activeIndex === 3 ? "-" : "+"}</span>
            </div>
            {activeIndex === 3 && (
              <div className="faq-answer">
                Yes you can cancel. we understand life will not run according to our plan. There is refund policies also Cancel up to 24 hours in advance for a full refund.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(4)}>
            <div className="faq-question">
              Preparation For This package
              <span>{activeIndex === 4 ? "-" : "+"}</span>
            </div>
            {activeIndex === 4 && (
              <div className="faq-answer">
                 <div className="heading smalling">What to Bring:</div>
  <div className="flex-p">
   <p style={{padding:"4px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'24px'}}/> <b>Dress in Layers:</b> Wear a warm down jacket over a fleece; temperatures drop significantly once you land in the mountains.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'24px'}}/> <b>Sun Protection:</b> High-altitude snow reflects intense light—bring UV-protection sunglasses and strong sunscreen.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'24px'}}/> <b>Device Prep:</b> Charge your phone and camera fully; the mountain cold can drain batteries faster than usual.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'24px'}}/> <b>Health & Hydration:</b> Drink plenty of water before the flight and carry a small bottle to help with the altitude.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'24px'}}/> <b>Quick Access:</b> Keep your ID/Passport copy and some local cash handy for Tipping or a Local Products at the Everest View Hotel.</p>
  </div>
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(5)}>
            <div className="faq-question">
              What about meal in this package?
              <span>{activeIndex === 5 ? "-" : "+"}</span>
            </div>
            {activeIndex === 5 && (
              <div className="faq-answer">
                The dining experience is a centerpiece of this journey, taking place at the world-famous Hotel Everest View. You will land on a ridge at nearly 3,900 meters to enjoy a freshly prepared breakfast on a terrace that faces the peaks of Everest, Ama Dablam, and Lhotse directly. Whether you choose a classic continental breakfast or a warm local dish, every bite is served with the crisp, clean air of the high Himalayas. It is a rare moment of luxury where you can sip hot Himalayan tea or coffee while watching the morning sun hit the world's tallest mountains. This isn't just a quick snack; it is a peaceful, one-hour escape designed to let you soak in the magic of the mountains in total comfort.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(6)}>
            <div className="faq-question">
              Do you provide customized tours?
              <span>{activeIndex === 6 ? "-" : "+"}</span>
            </div>
            {activeIndex === 6 && (
              <div className="faq-answer">
                Yes, we offer fully customizable travel experiences you can see button of customize below just click it and our travel expert will contact you.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(7)}>
            <div className="faq-question">
              What Language are available for this package?
              <span>{activeIndex === 7 ? "-" : "+"}</span>
            </div>
            {activeIndex === 7 && (
              <div className="faq-answer">
                Our guides speak English, Hindi, and Chinese.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(8)}>
            <div className="faq-question">
              Do you offer group discounts?
              <span>{activeIndex === 8 ? "-" : "+"}</span>
            </div>
            {activeIndex === 8 && (
              <div className="faq-answer">
                When you see right side in desktop and little bit below in mobile screen we made a system where total price is calculated according to number of people and there may be available of more discount for group which is not mention in this system than our booking team will mention it while enquiry or booking.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(9)}>
            <div className="faq-question">
              How can I contact support?
              <span>{activeIndex === 9 ? "-" : "+"}</span>
            </div>
            {activeIndex === 9 && (
              <div className="faq-answer">
                You can reach us via email, phone and many more just see our contact us page.
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  </div>
<div className="overview-container">
  <div className="heading">Why Choose Us ?</div>

  <div className="flex-p">
   <p>1. From past 7 years we are continuously providing great service to our customer.</p>
   <p>2. After Booking with us your task is only to enjoy your trip.</p>
   <p>3. You can customize your holiday with our Destination expert.</p>
   <p>4. Providing better quality in compitative price is our main goal.</p>
   <p>5. Until your depature to your own country all responsibility like security is our duty.</p>
  </div>
</div>
<div className="overview-container width-hund">
<div className="review-section">

<div className="review-heading">
  What Our Travelers Say
</div>

<div className="review-wrapper">

  {/* REVIEW 1 */}
  <div className="review-card">
    <div className="review-stars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="review-text">
      The Everest Heli Tour was a dream come true. The views were unreal and
      the helicopter experience was smooth and luxurious.
    </div>

    <div className="review-user">
      <div className="user-avatar">A</div>
      <div className="user-info">
        <div className="user-name">Alex Morgan</div>
        <div className="user-country">United Kingdom</div>
      </div>
    </div>
  </div>

  {/* REVIEW 2 */}
  <div className="review-card">
    <div className="review-stars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="review-text">
      Perfect for travelers with limited time. In just a few hours, we saw
      Everest up close without any physical effort.
    </div>

    <div className="review-user">
      <div className="user-avatar">S</div>
      <div className="user-info">
        <div className="user-name">Sophia Lee</div>
        <div className="user-country">Singapore</div>
      </div>
    </div>
  </div>

  {/* REVIEW 3 */}
  <div className="review-card">
    <div className="review-stars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="review-text">
      Highly recommended! Stunning mountain views, professional crew, and
      an unforgettable helicopter flight over the Himalayas.
    </div>

    <div className="review-user">
      <div className="user-avatar">R</div>
      <div className="user-info">
        <div className="user-name">Rahul Verma</div>
        <div className="user-country">India</div>
      </div>
    </div>
  </div>

</div>
</div>
</div>
<div className="cta-section">

<div className="cta-button book" onClick={()=>seT(true)}>
  <FontAwesomeIcon icon={faCalendarCheck} />
  <div className="cta-text">Book Now</div>
</div>

<div className="cta-button customize"onClick={()=>seTe(true)}>
  <FontAwesomeIcon icon={faSliders} />
  <div className="cta-text">Customize</div>
</div>

<div className="cta-button review"onClick={()=>seTr(true)} >
  <FontAwesomeIcon icon={faStar} />
  <div className="cta-text">Review</div>
</div>

</div>
    </div>
    <section id='price'>
    <div className='Right'>
        <div className="in-right">
         <div className="out-right">
            <div className="out-in-right"> 
            <h3>Starting Price</h3>
            <div className="price-tag">
              <div className="icon-price-tag">
               <FontAwesomeIcon icon={faTag} className='icon'/>
              </div>
              <div className="icon-details">
                 <div className="right-price">
                  <p>$1400</p>
                  <p className="per-person">/Per Person</p>
                 </div>
                 <p className='little'>All Price Inclusive</p>
            </div>
            </div>
            </div>
            <div className="number-of-traveller">
              <p>Number Of Travellers</p>
              <p className='lt'><FontAwesomeIcon icon={faBolt}></FontAwesomeIcon>Price Decreases When Travellers Increases</p>
              <div className="people-box">
              <FontAwesomeIcon icon={faMinus} className='people-box-icon'onClick={()=>{if(count>1){Setcount(count-1)}}}/>
                <p className='count'>{count}</p>
                <FontAwesomeIcon icon={faPlus} className='people-box-icon'onClick={()=>{Setcount(count+1)}}/>
              </div>
              <div className='Total-Amount'>
                <p className='total-price'>Total Amount</p>
                <p>${totalprice}</p>
              </div>
              <div className="booking-button">
                <Link to="/Terms" className="download">
                  <h6>See Terms & Condition</h6>
                </Link>
                <div className="booking-btn">
                  <button onClick={()=>seT(true)}>Book Now</button>
                  <button  onClick={()=>seTe(true)}>Enquiry Now</button>
                </div>
              </div>
            </div>
         </div>
         </div>
         <div className="tour-rep-section">
      <h2 className="section-heading">Trip Expert</h2>
      
       <div className="rep-card">
        <div className="image-container">
          <img 
            src="/img/company/destination expert.webp" 
            alt="Sales Manager" 
            className="rep-image" 
          />
        </div>
        
        <div className="rep-info">
          <h3 className="rep-name">Bishnu Pandey</h3>
          
          <div className="contact-item">
            <FontAwesomeIcon icon={faWhatsapp} className="icon effect" />
            <span>+977-9863841456</span>
          </div>
          
          <div className="contact-item">
            <FontAwesomeIcon icon={faWeixin} className="icon effect" />
            <span>Bishnu Pandey</span>
          </div>
          
          <div className="contact-item">
            <FontAwesomeIcon icon={faEnvelope} className="icon" />
            <a href="mailto:sales@yourtravelco.com">012shy1234@gmail.com</a>
          </div>
        </div>
      </div>
    </div>
        </div>
        </section>
   </div>
     <h2 className="hws">Similar Packages</h2>
     <PackageSlider packages={packages} />
     <section className='sticky-bott'>
     <div className="booking-btn">
                  <button onClick={()=>seT(true)}>Book Now</button>
                  <button onClick={()=>seTe(true)}>Enquiry Now</button>
    </div>
     </section>
     {opent &&( <section className="bookings">
      <div
      className="sw"
      onClick={() => seT(false)}
    >
      Back
      
    </div>
   <OBookingform src="/img/mounteve/Heli.webp" title="4 Hour Everest Tour"/></section>)}
{opente &&( <section className="bookings">
      <div
      className="sw"
      onClick={() => seTe(false)}
    >
      Back
      
    </div>
    <Enquiryform src="/img/mounteve/Heli.webp" title="4 Hour Everest Tour"/></section>)}
{openr &&( <section className="bookings">
  <div
  className="sw"
  onClick={() => seTr(false)}
>
  Back
  
</div>
<Review /></section>)}
   </main>
  )
}
export default EverestHeliTour